import axiosClient from "api/apiClient";

interface IOptions {
    id?: string;
    sort?: string;
    search?: string;
}

export const APIGetCustomItem = (options: IOptions) => {
    let sort = "";
    let search = "";
    if (options.hasOwnProperty("sort")) {
        sort = "&sort=" + options.sort;
    }
    if (options.hasOwnProperty("search")) {
        search = "&filter[search]=" + options.sort;
    }
    return axiosClient.get(`/personalItems/${options.id}?${search}${sort}`);
};

export const APIArchiveCustomItem = (options: IOptions) => {
    return axiosClient.post(`/personalItems/archive/${options.id}`);
};

export const APIRestoreCustomItem = (options: IOptions) => {
    return axiosClient.post(`/personalItems/restore/${options.id}`);
};

export const APIUpdateCustomItem = (id: string, data: object) => {
    return axiosClient.put(`/personalItems/${id}`, data);
};

export const APIPostCustomItem = (data: object) => {
    return axiosClient.post(`/personalItems`, data);
};

export const APIPostCustomSubcategories = (data: object) => {
    return axiosClient.post("/personal-items-subcategories/listByTypeAndGrade", data);
};
